export const RENOLOG_LOCAL_API_REQUESTS = false;
export const RENOLOG_ADMIN_LOCAL_API_REQUESTS = false;
